module.exports = __webpack_public_path__ + "assets/img/18_182.6361bedb.jpg";